import {Partner } from "../models/partner.model";

export const PARTNERS: Partner[] =[
  {
    'fileName': 'merrill-lynch.jpg',
    'name': 'Merrill Lynch',
  },
  {
    'fileName': 'jpmorgan.jpg',
    'name': '',
  },
  {
    'fileName': 'credit-suisse.jpg',
    'name': 'Credit Suisse',
  },
  {
    'fileName': 'goldman-sachs.jpg',
    'name': 'Goldman Sachs',
  },
  {
    'fileName': 'deutsche-bank.jpg',
    'name': 'Deutsche Bank',
  },
  {
    'fileName': 'citi.jpg',
    'name': 'City',
  },
  {
    'fileName': 'morgan-stanley.jpg',
    'name': 'Morgan Stanley',
  },
  {
    'fileName': 'ubs.jpg',
    'name': 'UBS',
  },
  {
    'fileName': 'barclays.jpg',
    'name': 'Barclays',
  },
  {
    'fileName': 'deloitte.jpg',
    'name': 'Deloitte',
  },
  {
    'fileName': 'ey.jpg',
    'name': 'EY',
  },
  {
    'fileName': 'kpmg.jpg',
    'name': 'KPMG',
  },
  {
    'fileName': 'bain.jpg',
    'name': 'Bain Capital',
  },
  {
    'fileName': 'bcg.jpg',
    'name': 'BCG',
  },
  {
    'fileName': 'mc.jpg',
    'name': 'McKinsey&Company',
  },
  {
    'fileName': 'pwc.jpg',
    'name': 'PWC',
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/partners.ts